import { motion } from "framer-motion";

export const MaskedLines = ({ lines, className = "", delay = 0.15, as = "h1", testId }) => {
  const Tag = as;
  return (
    <Tag className={className} data-testid={testId}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <motion.span
            className="block will-change-transform"
            initial={{ y: "108%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.05, delay: delay + i * 0.13, ease: [0.16, 1, 0.3, 1] }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const PixelCluster = ({ className = "" }) => (
  <span aria-hidden="true" className={`inline-grid grid-cols-3 gap-[3px] ${className}`}>
    {[1, 0, 1, 1, 1, 0, 0, 1, 1].map((on, i) => (
      <span key={i} className={`h-[5px] w-[5px] rounded-[1px] ${on ? "bg-gradient-to-br from-cyan-400 to-blue-500" : "bg-transparent"}`} />
    ))}
  </span>
);

export const PageHero = ({ eyebrow, lines, text, children, testId = "page-hero" }) => (
  <section className="grain relative overflow-hidden bg-[#030712] pb-20 pt-36 text-white sm:pt-44 lg:pb-28" data-testid={testId}>
    <div className="grid-dark pointer-events-none absolute inset-0 [mask-image:radial-gradient(ellipse_at_top_left,black_30%,transparent_75%)]" />
    <div className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-violet-600/20 blur-[120px]" />
    <div className="pointer-events-none absolute -left-20 top-20 h-[360px] w-[360px] rounded-full bg-cyan-500/10 blur-[110px]" />
    <div className="container-q relative">
      <motion.p initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="eyebrow flex items-center gap-3 text-cyan-300">
        <PixelCluster /> {eyebrow}
      </motion.p>
      <MaskedLines lines={lines} className="mt-7 max-w-5xl text-[2.5rem] font-extrabold leading-[1.02] tracking-[-0.04em] sm:text-6xl lg:text-7xl" testId={`${testId}-title`} />
      {text && (
        <motion.p initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.5 }} className="mt-8 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">
          {text}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
